import {
  HttpErrorResponse, HttpEvent, HttpHandler,
  HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppError, AppErrorType } from './app-error';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    return next.handle(request).pipe(catchError((error: HttpErrorResponse) => {

      if (error.error instanceof ErrorEvent) {
        // client-side error
        console.error(`Front-end error: ${error.error.message}`, error);
        return this.createError({
          type: AppErrorType.CLIENT_SIDE,
          message: error.error.message,
          cause: error
        });
      }

      // server-side error
      console.error('Back-end error:', error.status);
      console.error('Message:', error.message);
      console.error(error);

      if (error.status >= 400 && error.status < 500) {
        return this.createError({
          type: AppErrorType.SERVER_SIDE,
          message: error.error.message,
          cause: error
        });
      }
      return this.createError({
        type: AppErrorType.SERVER_SIDE,
        message: error.message,
        cause: error
      });
    }));
  }

  private createError(appError: AppError): Observable<HttpEvent<unknown>> {
    return throwError(appError);
  }
}
